// extracted by mini-css-extract-plugin
export default {"vacancies":"Vacancies_vacancies__9A9rd"};